/* eslint-disable @typescript-eslint/no-explicit-any,react/destructuring-assignment,class-methods-use-this */
// TODO: fix type any
import parse from 'html-react-parser';
import { PureComponent } from 'react';
import { toast } from 'react-toastify';
import AudioSubtitleBlock from '@/components/tour/regular/sweep/AudioSubtitleBlock';
import { SweepType } from '../../../../_models/Sweep';
import {
  AudioModule,
  MusicObj,
  MusicObjectKey,
} from '../../../../components-new/common/AudioModule';
import { CloseButton, FullscreenButton } from '../../../../units';
import Iframe from '../../../../units/Iframe';
import * as all from '../../../util/all';
import { getVersion } from '../../../util/all';
import { sendToGA } from '../../../util/analytic';
import DeviceManager from '../../../util/deviceManager';
import AdRedesigned from '../ad-redesigned/AdRedesigned';
import FullScreen from '../fullScreen/FullScreen';
import { SweepTextWrap } from './styled';
import { subtitleIntervalListener } from './utils';
import { FAIcon } from '@packages/ui-components';

const audioHandler = AudioModule.getInstance();

export default class Sweep extends PureComponent<any, any> {
  handledError = false;

  playedGroups: any = {};

  playedUniqueGroups: any = {};

  closedGroups: any = {};

  closedUniqueGroups: any = {};

  greenScreenVideo: any;

  leadNameRef: React.RefObject<HTMLInputElement>;

  leadEmailRef: React.RefObject<HTMLInputElement>;

  leadPhoneRef: React.RefObject<HTMLInputElement>;

  leadMessageRef: React.RefObject<HTMLTextAreaElement>;

  leadLegalBoxRef: React.RefObject<HTMLInputElement>;

  leadLegalBox2Ref: React.RefObject<HTMLInputElement>;

  constructor(props: any) {
    super(props);
    this.state = {
      group: null,
      show: false,
      currentSubText: null,
    };
  }

  componentDidMount() {
    if (!this.props.show) return;
    this.processSweepGroup();
  }

  componentDidUpdate(props: any) {
    if (!this.props.show) return;

    const { selectedGroup, show } = this.props;
    if (props.selectedGroup !== selectedGroup || props.show !== show) {
      this.processSweepGroup({ prevGroup: props.selectedGroup });
    }
  }

  processSweepGroup({ prevGroup = null } = {}) {
    const { selectedGroup, groups } = this.props;

    const group = selectedGroup ? groups.find((sg: any) => sg.id === selectedGroup) : null;

    const lastGroup = this.state.group;

    audioHandler.setGreenScreenPlaying(false);

    // Show either current group, or keep showing if lastGroup wasn't closed
    let show = group || (lastGroup && !this.closedGroups[lastGroup.id]);
    if (group) {
      const groupIsUnique = group.uniqueId && group.uniqueId.length > 0;

      if (groupIsUnique) {
        // If group unique id was closed, don't open it again (depends on replay)
        if (!group.replay && this.playedUniqueGroups[group.uniqueId]) {
          show = false;
        } else if (!group.replay) {
          this.playedUniqueGroups[group.uniqueId] = true;
        }

        // Don't reopen if closed inside the group
        if (
          lastGroup &&
          lastGroup.uniqueId === group.uniqueId &&
          this.closedUniqueGroups[group.uniqueId]
        ) {
          show = false;
        }
      } else if (!group.replay && this.playedGroups[group.id]) {
        show = false;
      } else if (!group.replay) {
        this.playedGroups[group.id] = true;
      }
      sendToGA('event', {
        eventCategory: 'SweepGroup',
        eventAction: 'move',
        eventLabel: group.title,
      });
    }

    this.props.setIsSubtitleVisible(false);
    this.setState(
      {
        // group: group || lastGroup, // lastGroup to keep old group if moving
        group: group,
        show,
        currentSubText: null,
      },
      async () => {
        const { interacted, onInteractedChange, videoContainer } = this.props;

        if (!show || !group) {
          await audioHandler.stopAudioByType(MusicObjectKey.SWEEPGROUPS);
          return;
        }
        onInteractedChange(true);

        // interacted
        if (group.type === SweepType.GreenScreen && this.greenScreenVideo) {
          if (DeviceManager.supportsTouch()) {
            onInteractedChange(false);
            document.addEventListener(
              'touchstart',
              async () => {
                onInteractedChange(true);
                await this.playGreenScreen();
              },
              { once: true },
            );
          } else if (!interacted || DeviceManager.isMobile()) {
            onInteractedChange(false);
            document.addEventListener(
              'click',
              async () => {
                onInteractedChange(true);
                await this.playGreenScreen();
              },
              { once: true },
            );
          } else {
            await this.playGreenScreen();
          }

          audioHandler.pauseAllMusic();
        }

        if (group.type === SweepType.Music) {
          if (this.props.noAudioMode) return;

          if (!group.music) {
            toast.error('Music source not found.');
            return;
          }
          audioHandler.pauseAllMusic();

          if (this.props.renderer?.xr?.enabled && this.props.renderer?.xr?.isPresenting) {
            setTimeout(this.checkAndApplyAudioCaptionsDisplay, 200);
            await audioHandler.playAudio({ type: MusicObj.SWEEPGROUPS, id: group.id });
          } else if (DeviceManager.supportsTouch()) {
            // we force touch to play music
            onInteractedChange(false);
            document.addEventListener(
              'touchstart',
              async () => {
                onInteractedChange(true);
                setTimeout(this.checkAndApplyAudioCaptionsDisplay, 200);
                await audioHandler.playAudio({ type: MusicObj.SWEEPGROUPS, id: group.id });
              },
              { once: true },
            );
          } else if (!interacted || DeviceManager.isMobile()) {
            onInteractedChange(false);
            document.addEventListener(
              'click',
              async () => {
                onInteractedChange(true);
                setTimeout(this.checkAndApplyAudioCaptionsDisplay, 200);
                await audioHandler.playAudio({ type: MusicObj.SWEEPGROUPS, id: group.id });
              },
              { once: true },
            );
          } else {
            setTimeout(this.checkAndApplyAudioCaptionsDisplay, 200);
            await audioHandler.playAudio({ type: MusicObj.SWEEPGROUPS, id: group.id });
          }
        }

        if (group.type === SweepType.Tab) {
          window.open(group.url, '_blank');
        }

        if (group.type === SweepType.Panorama && prevGroup !== group?.id) {
          this.props.showPanoramaClick(group.panoramaId);
        }

        if (group.type === SweepType.Video) {
          videoContainer.pause();
        }
      },
    );
  }

  validateEmail(email: string) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  close = async (group: any) => {
    this.closedUniqueGroups[group.uniqueId] = true;
    this.closedGroups[group.id] = true;

    if (group.type === SweepType.Video) {
      this.props.videoContainer.play();
    }

    this.setState({ show: false });
    this.props.setIsSubtitleVisible(false);
  };

  playAudio = async () => {
    const { group } = this.state;
    await audioHandler.playAudio({ type: MusicObj.SWEEPGROUPS, id: group.id });

    // start subtitles?
    if (!this.handledError && group.musicSubsEnabled && Array.isArray(group.musicSubs))
      setTimeout(this.checkAndApplyAudioCaptionsDisplay, 200);
  };

  checkAndApplyAudioCaptionsDisplay = async () => {
    const { group } = this.state;
    const allData = await audioHandler.getAllMusicData();
    // @ts-ignore
    const audio = allData?.SWEEPGROUPS && allData?.SWEEPGROUPS[group?.id];
    if (!audio) return;
    if (group.musicSubs?.length) {
      // Audio is a Howl object
      if (audio && this.props.tourReadyForAudio) {
        subtitleIntervalListener(audio, group, (subtitle) => {
          if (subtitle) {
            this.props.setIsSubtitleVisible(true);
            this.setState({ currentSubText: subtitle.text });
          } else {
            this.props.setIsSubtitleVisible(false);
            this.setState({ currentSubText: null });
          }
        });
      } else {
        setTimeout(this.checkAndApplyAudioCaptionsDisplay, 200);
      }
    }
  };

  playGreenScreen = async () => {
    try {
      await this.greenScreenVideo.play();
      audioHandler.setGreenScreenPlaying(true);
    } catch (e) {
      setTimeout(this.playGreenScreen, 500);
    }
  };

  public render() {
    if (!this.props.show) return null;

    const { show, group, currentSubText } = this.state;
    const { logo, hideSubtitlesGroupId, tour, tourEmail, translation, whitelabel, flowIsActive } =
      this.props;
    const { client } = tour;
    const isMobile = DeviceManager.isMobile();
    const hasGreenScreenVideo =
      group &&
      group.type === SweepType.GreenScreen &&
      group[isMobile ? 'greenScreenWebmMobile' : 'greenScreenWebm'] &&
      group[isMobile ? 'greenScreenMovMobile' : 'greenScreenMov'];

    // default is 'center', no need to update anything
    let videoPositionStyles: any = {};
    if (group?.videoPosition === 'bottomRight') {
      videoPositionStyles = {
        left: 'auto',
        top: 'auto',
        bottom: '16px',
        right: '40px',
      };
    } else if (group?.videoPosition === 'bottomLeft') {
      videoPositionStyles = {
        left: '16px',
        top: 'auto',
        bottom: '16px',
        right: 'auto',
      };
    }

    // @ts-ignore
    return (
      <div className="sweep-component">
        {group?.type === SweepType.Text && show && (
          <div
            className="popup sweep-pop text"
            style={{
              height: `${group[isMobile ? 'heightMobile' : 'height']}${
                group.res === 'pixels' ? 'px' : 'vw'
              }`,
              width: `${group[isMobile ? 'widthMobile' : 'width']}${
                group.res === 'pixels' ? 'px' : 'vw'
              }`,
            }}
          >
            <CloseButton
              onClick={() => {
                this.close(group);
              }}
              isFullscreen={false}
            />
            <SweepTextWrap>{parse(group.text)}</SweepTextWrap>
          </div>
        )}
        {group?.type === SweepType.Image && show && group.leads && (
          <AdRedesigned
            to={(tourEmail && tourEmail.leadForms) || (tour.client && tour.client.email)}
            tour={tour}
            translation={translation}
            rtl={this.state.rtl}
            whitelabel={whitelabel}
            form={{
              imageSrc: `${process.env.NEXT_PUBLIC_CDN}/tours/${group.tourId}/sweeps/${
                group.image
              }${getVersion(group.updatedAt)}`,
              phone: group.leadsScansPhone,
              name: group.leadsScansName,
              email: group.leadsScansEmail,
              url: group.leadsScansUrl,
              checkbox1: group.leadsScansLegalCheckbox1,
              checkbox2: group.leadsScansLegalCheckbox2,
            }}
          />
        )}
        {group?.type === SweepType.Image && show && !group.leads && (
          <div
            className="popup sweep-pop image adPop s"
            style={{
              height: `${group[isMobile ? 'heightMobile' : 'height']}${
                group.res === 'pixels' ? 'px' : 'vw'
              }`,
              width: `${group[isMobile ? 'widthMobile' : 'width']}${
                group.res === 'pixels' ? 'px' : 'vw'
              }`,
            }}
          >
            <CloseButton
              onClick={() => {
                this.close(group);
              }}
              isFullscreen={false}
            />
            <div
              className="img"
              style={{
                backgroundImage: `url(${process.env.NEXT_PUBLIC_CDN}/tours/${group.tourId}${
                  isMobile ? '/mobile' : ''
                }/sweeps/${group[isMobile ? 'imageMobile' : 'image']})`,
              }}
            />
          </div>
        )}
        {group?.type === SweepType.Video && show && (
          <div
            className="popup sweep-pop video"
            style={{
              height: `${group[isMobile ? 'heightMobile' : 'height']}${
                group.res === 'pixels' ? 'px' : 'vw'
              }`,
              width: `${group[isMobile ? 'widthMobile' : 'width']}${
                group.res === 'pixels' ? 'px' : 'vw'
              }`,
              ...videoPositionStyles,
            }}
          >
            <FullScreen
              attrs={{
                id: 'sweep-video-fullscreen',
                styles: { background: 'transparent' },
              }}
              startFullscreen={group.fullscreen}
            >
              {({ isFullScreen, toggleFullscreen }) => (
                <>
                  <CloseButton
                    onClick={() => {
                      this.close(group);
                    }}
                    isFullscreen={isFullScreen || (group.res !== 'pixels' && group.width > 95)}
                  />
                  <FullscreenButton
                    onClick={toggleFullscreen}
                    isFullscreen={isFullScreen || (group.res !== 'pixels' && group.width > 95)}
                  />
                  <Iframe
                    logoSrc={logo}
                    allowFullscreen
                    src={all.getVideoLink(group.url, {
                      mute: this.props.noAudioMode || group.autoPlay,
                      autoplay: group.autoPlay,
                    })}
                    frameBorder="0"
                    autoplay={group.autoPlay}
                    url={group.url}
                    mute={this.props.noAudioMode}
                    group={group}
                  />
                </>
              )}
            </FullScreen>
          </div>
        )}
        {group?.type === SweepType.Iframe && show && (
          <div
            className="popup sweep-pop iframe"
            style={{
              height: `${group[isMobile ? 'heightMobile' : 'height']}${
                group.res === 'pixels' ? 'px' : 'vw'
              }`,
              width: `${group[isMobile ? 'widthMobile' : 'width']}${
                group.res === 'pixels' ? 'px' : 'vw'
              }`,
            }}
          >
            <CloseButton
              onClick={() => {
                this.close(group);
              }}
              isFullscreen={false}
            />
            <Iframe logoSrc={logo} src={group.url} frameBorder="0" allowFullscreen />
          </div>
        )}
        {hasGreenScreenVideo && show && (
          <div
            className={`popup sweep-pop green-screen ${group.videoSide}`}
            style={{
              height: `${group[isMobile ? 'heightMobile' : 'height']}${
                group.res === 'pixels' ? 'px' : 'vw'
              }`,
              width: `${group[isMobile ? 'widthMobile' : 'width']}${
                group.res === 'pixels' ? 'px' : 'vw'
              }`,
            }}
          >
            <div
              className="close"
              onClick={() => {
                this.close(group);
              }}
            >
              <FAIcon icon="faTimes" />
            </div>
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <video
              controls={false}
              autoPlay={false}
              playsInline
              muted={this.props.noAudioMode}
              ref={(el: any) => {
                this.greenScreenVideo = el;
              }}
              key={`group-id-${group.uniqueId}`}
            >
              <source
                src={`${process.env.NEXT_PUBLIC_CDN}/tours/${group.tourId}${
                  isMobile ? '/mobile' : ''
                }/sweeps/${group[isMobile ? 'greenScreenMovMobile' : 'greenScreenMov']}`}
                type="video/quicktime"
              />
              <source
                src={`${process.env.NEXT_PUBLIC_CDN}/tours/${group.tourId}${
                  isMobile ? '/mobile' : ''
                }/sweeps/${group[isMobile ? 'greenScreenWebmMobile' : 'greenScreenWebm']}`}
                type="video/webm"
              />
            </video>
          </div>
        )}
        <AudioSubtitleBlock
          isRtl={client?.rtl}
          currentSubText={currentSubText}
          group={group}
          hideSubtitlesGroupId={hideSubtitlesGroupId}
          flowIsActive={flowIsActive}
        />
      </div>
    );
  }
}
